module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Extinguisher-Foam/Fire-Extinguisher-Foam.svg";